export const AppRoutes = {
  HOME: "/",
  GALLERY: "/gallery",
  TEAMS: "/teams",
  REVIEWS: "/reviews",
};
